
import React from 'react';
import { useTheme } from '@/providers/ThemeProvider';
import { Moon, Sun } from 'lucide-react';
import { Switch } from '@/components/ui/switch';

export const ThemeToggle = () => {
  // Use try/catch to gracefully handle the case when ThemeToggle is rendered 
  // outside of a ThemeProvider
  try {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === 'dark';

    return (
      <div className="flex items-center gap-2">
        <Sun className={`h-[1.2rem] w-[1.2rem] transition-colors duration-300 ${isDark ? 'text-gray-600' : 'text-amber-500'}`} />
        <Switch 
          checked={isDark}
          onCheckedChange={toggleTheme}
          aria-label="Toggle theme"
          className={`${isDark ? 'bg-blue-700' : ''}`}
        />
        <Moon className={`h-[1.2rem] w-[1.2rem] transition-colors duration-300 ${isDark ? 'text-blue-400' : 'text-gray-500'}`} />
      </div>
    );
  } catch (error) {
    // If ThemeProvider is not available, render nothing or a fallback UI
    console.warn('ThemeToggle rendered outside ThemeProvider');
    return null;
  }
};
